// extracted by mini-css-extract-plugin
export default {"learning_options_container":"LearningOptions_learning_options_container__zfekK","learning_option_button":"LearningOptions_learning_option_button__RnJpY"};